import { render, staticRenderFns } from "./Sortable.vue?vue&type=template&id=f3d03fd2"
import script from "./Sortable.vue?vue&type=script&lang=js"
export * from "./Sortable.vue?vue&type=script&lang=js"
import style0 from "./Sortable.vue?vue&type=style&index=0&id=f3d03fd2&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports